var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachmentWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_6348",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.28125,
    width: 18.7197,
    height: 18.7197,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_6348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4799 8.86169V4.96175H14.0399V8.86169H12.4799ZM8.57998 14.2436C8.12498 14.1136 7.75124 13.8601 7.45874 13.4831C7.16625 13.1061 7.02 12.6706 7.02 12.1766V4.96175H8.57998V14.2436ZM9.16497 17.4416C7.81299 17.4416 6.6625 16.9671 5.71352 16.0181C4.76453 15.0691 4.29004 13.9186 4.29004 12.5666V5.35175C4.29004 4.37676 4.63128 3.54802 5.31377 2.86553C5.99626 2.18304 6.825 1.8418 7.79999 1.8418C8.77497 1.8418 9.60371 2.18304 10.2862 2.86553C10.9687 3.54802 11.3099 4.37676 11.3099 5.35175V11.2017H9.74996V5.35175C9.73696 4.80575 9.54521 4.34426 9.17472 3.96727C8.80422 3.59027 8.34598 3.40177 7.79999 3.40177C7.254 3.40177 6.7925 3.59027 6.41551 3.96727C6.03851 4.34426 5.85002 4.80575 5.85002 5.35175V12.5666C5.83702 13.4896 6.15551 14.2729 6.8055 14.9164C7.45549 15.5598 8.24198 15.8816 9.16497 15.8816C9.48996 15.8816 9.79871 15.8393 10.0912 15.7548C10.3837 15.6703 10.6599 15.5436 10.9199 15.3746V17.1101C10.6469 17.2141 10.3642 17.2953 10.0717 17.3538C9.77921 17.4123 9.47696 17.4416 9.16497 17.4416ZM12.4799 16.6616V14.3216H10.14V12.7616H12.4799V10.4217H14.0399V12.7616H16.3799V14.3216H14.0399V16.6616H12.4799Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentWhiteIcon);
export default __webpack_public_path__ + "static/media/attachmentWhiteIcon.19f553246eba6f1ee1184c4deb13e65b.svg";
export { ForwardRef as ReactComponent };